'use client';

import { createContext, JSX, useContext, useState } from 'react';

export interface DialogItem {
    id: string;
    component: JSX.Element;
}

interface DialogContextType {
    dialogs: DialogItem[];
    // eslint-disable-next-line no-unused-vars
    enqueueDialog: (component: JSX.Element) => void;
    dequeueDialog: () => void;
}

const DialogContext = createContext<DialogContextType>({
    dialogs: [],
    enqueueDialog: () => {},
    dequeueDialog: () => {},
});

export const useDialogContext = () => useContext(DialogContext);

export const DialogProvider = ({ children }: { children: React.ReactNode }) => {
    const [dialogs, setDialogs] = useState<DialogItem[]>([]);

    const enqueueDialog = (component: JSX.Element) => {
        setDialogs((prevDialogs) => [...prevDialogs, { id: Math.random().toString(), component }]);
    };

    const dequeueDialog = () => {
        setDialogs((prevDialogs) => prevDialogs.slice(0, -1));
    };

    return (
        <DialogContext.Provider value={{ dialogs, enqueueDialog, dequeueDialog }}>
            {children}
        </DialogContext.Provider>
    );
};

export default DialogContext;
